// Lightweight canvas confetti — no deps.
// Usage: import {burstConfetti} from '@common/Confetti'; burstConfetti();

const COLORS = ['#2f8f57', '#34a762', '#f5a623', '#4a7fd4', '#7b68a8', '#fff'];

let canvas = null;
let ctx = null;
let particles = [];
let rafId = null;

function ensureCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.className = 'resume-confetti-canvas';
    canvas.style.position = 'fixed';
    canvas.style.inset = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '9999';
    document.body.appendChild(canvas);
    resize();
    window.addEventListener('resize', resize);
}

function resize() {
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
}

function spawnParticle(originX, originY) {
    const angle = (Math.random() * Math.PI) - Math.PI / 2; // upward spread
    const velocity = 6 + Math.random() * 10;
    return {
        x: originX,
        y: originY,
        vx: Math.cos(angle) * velocity * (Math.random() > 0.5 ? 1 : -0.6),
        vy: Math.sin(angle) * velocity - 4,
        size: 6 + Math.random() * 6,
        rotation: Math.random() * Math.PI * 2,
        rotationSpeed: (Math.random() - 0.5) * 0.3,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        life: 0,
        maxLife: 90 + Math.random() * 40,
        shape: Math.random() > 0.5 ? 'rect' : 'circle',
    };
}

function step() {
    if (!ctx || !canvas) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    particles.forEach(p => {
        p.vy += 0.35; // gravity
        p.vx *= 0.99; // air drag
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.rotationSpeed;
        p.life++;

        const alpha = Math.max(0, 1 - p.life / p.maxLife);
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        if (p.shape === 'rect') {
            ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        } else {
            ctx.beginPath();
            ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
            ctx.fill();
        }
        ctx.restore();
    });

    particles = particles.filter(p => p.life < p.maxLife && p.y < window.innerHeight + 60);

    if (particles.length > 0) {
        rafId = requestAnimationFrame(step);
    } else {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
        if (canvas) {
            canvas.remove();
            canvas = null;
            ctx = null;
            window.removeEventListener('resize', resize);
        }
    }
}

export function burstConfetti({count = 120, origin} = {}) {
    ensureCanvas();
    const x = origin?.x ?? window.innerWidth / 2;
    const y = origin?.y ?? window.innerHeight * 0.6;

    for (let i = 0; i < count; i++) {
        particles.push(spawnParticle(x, y));
    }

    if (!rafId) {
        rafId = requestAnimationFrame(step);
    }
}
